<div class="banner">
    <picture>
        @for (item of heroImages; track item) {
        <source media="(max-width: {{item.maxWidth}}px)" srcset="assets/img/hero/{{item.image}}">
        @if (item.maxWidth === 1800) {
        <img src="assets/img/hero/{{item.image}}"  alt="hero">
        }
        }
    </picture>
    <div class="img-overlay">
        <picture>
            @for (item of overlayImages; track item) {
            <source media="(max-width: {{item.maxWidth}}px)" srcset="assets/img/overlay/{{item.image}}">
            @if (item.maxWidth === 1800) {
            <img src="assets/img/overlay/{{item.image}}" alt="{{item.alt}}">
            }
            }
        </picture>
    </div>
    <div class="text-overlay">
        <p>{{overlayText}}</p>
    </div>
    <div class="ourstory">
        <p>{{ourstory}}</p>
    </div>
</div>